import { Result } from "antd";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { roles } from "../config/roles";
import AccountSetup from "../screens/Auth/AccountSetup/AccountSetup";
import CreatePassword from "../screens/Auth/CreatePassword/CreatePassword";
import ForgetPassword from "../screens/Auth/ForgotPassword/ForgotPassword";
import Login from "../screens/Auth/Login/Login";
import Signup from "../screens/Auth/SignUp/Signup";
import VerificationProcess from "../screens/Auth/VerificationProcess/VerificationProcess";
import VerifyCode from "../screens/Auth/VerifyCode/VerifyCode";

import { ProtectedLayout, ProtectedRoute } from "./ProtectedRoutes";
import { HomeLayout, RolesLayout } from "./PublicRoutes";
import TermsConditions from "../screens/TermsConditions/TermsConditions";
import PrivacyPolicy from "../screens/PrivacyPolicy/PrivacyPolicy";
import ContactUs from "../screens/ContactUs/ContactUs";
import Faqs from "../screens/Faqs/Faqs";
import EmergencyContacts from "../screens/EmergencyContacts/EmergencyContacts";
import HelpSupport from "../screens/HelpSupport/HelpSupport";
import Notifications from "../screens/Notifications/Notifications";
import SignupCode from "../screens/Auth/SignupCode/SignupCode";
import AdminSelectPlan from "../screens/AdminScreens/AdminSelectPlan/AdminSelectPlan";
import AdminPayments from "../screens/AdminScreens/AdminPayment/AdminPayments";
import AdminBakerySetup from "../screens/AdminScreens/AdminBakerySetup/AdminBakerySetup";
import AdminDashboard from "../screens/AdminScreens/AdminDashboard/AdminDashboard";
import AdminStaffMgmt from "../screens/AdminScreens/AdminUserManagement/AdminStaffManagement/AdminStaffMgmt";
import CreateNewStaffUser from "../screens/AdminScreens/AdminUserManagement/AdminCreateNewStaffUser/CreateNewStaffUser";
import SupervisorDashboard from "../screens/SupervisorScreens/SupervisorDashboard/SupervisorDashboard";
import StaffDashboard from "../screens/StaffScreens/StaffDashboard/StaffDashboard";
import Settings from "../screens/settings/Settings";
// import AdminEditProfile from "../screens/AdminScreens/";
import AdminOrderManagement from "../screens/AdminScreens/AdminProductionManagement/AdminOrderManagement/AdminOrderManagement";
import EquipmentManagement from "../screens/AdminScreens/AdminProductionManagement/EquipmentManagement/EquipmentManagement";
import ProductionSchedule from "../screens/AdminScreens/AdminProductionManagement/ProductionSchedule/ProductionSchedule";
import AddEquipment from "../screens/AdminScreens/AdminProductionManagement/EquipmentManagement/AddEquipment/AddEquipment";
import EditEquipment from "../screens/AdminScreens/AdminProductionManagement/EquipmentManagement/EditEquipment/EditEquipment";
import EquipmentDetails from "../screens/AdminScreens/AdminProductionManagement/EquipmentManagement/EquipmentDetails/EquipmentDetails";
import ViewOrder from "../screens/AdminScreens/AdminProductionManagement/AdminOrderManagement/ViewOrder/ViewOrder";
import EditOrder from "../screens/AdminScreens/AdminProductionManagement/AdminOrderManagement/EditOrder/EditOrder";
import BakerySetup from "../screens/AdminScreens/AdminBuisnessManagement/BakerySetup/BakerySetup";
import LocationManagement from "../screens/AdminScreens/AdminBuisnessManagement/LocationManagement/LocationManagement";
import CreateOrder from "../screens/AdminScreens/AdminProductionManagement/AdminOrderManagement/CreateOrder/CreateOrder";
import EditBakeryDetail from "../screens/AdminScreens/AdminBuisnessManagement/LocationManagement/BasicInfoLocationManagement/EditBakeryDetail/EditBakeryDetail";

// AdminMaterialManagement
import AdminCustomerManagement from "../screens/AdminScreens/AdminRelationshipManagement/CustomerManagement/CustomerManagement";
import AdminAddCustomer from "../screens/AdminScreens/AdminRelationshipManagement/CustomerManagement/AddCustomer/AddCustomer";
import AdminEditCustomer from "../screens/AdminScreens/AdminRelationshipManagement/CustomerManagement/EditCustomer/EditCustomer";
import AdminEditVendor from "../screens/AdminScreens/AdminRelationshipManagement/VendorManagement/EditVendor/EditVendor";
import CustomerManagementDetails from "../screens/AdminScreens/AdminRelationshipManagement/CustomerManagement/CustomerManagementDetails/CustomerManagementDetails";
import OrderHistoryDetails from "../screens/AdminScreens/AdminRelationshipManagement/CustomerManagement/OrderHistory/OrderHistoryDetails/OrderHistoryDetails";
import OrderHistoryEditOrder from "../screens/AdminScreens/AdminRelationshipManagement/CustomerManagement/OrderHistory/OrderHistoryEditOrder/OrderHistoryEditOrder";
import OrderHistoryProductJourney from "../screens/AdminScreens/AdminRelationshipManagement/CustomerManagement/OrderHistory/OrderHistoryProductJourney/OrderHistoryProductJourney";
import AdminVendorManagement from "../screens/AdminScreens/AdminRelationshipManagement/VendorManagement/VendorManagement";
import AdminAddVendor from "../screens/AdminScreens/AdminRelationshipManagement/VendorManagement/AddVendor/AddVendor";
import VendorManagementDetails from "../screens/AdminScreens/AdminRelationshipManagement/VendorManagement/VendorManagementDetails/VendorManagementDetails";
// Warehouse/IngredientsManagement
import IngredientsMgmt from "../screens/AdminScreens/Warehouse/IngredientsManagement/Ingredients/IngredientsMgmt";
import CreateNewGradient from "../screens/AdminScreens/Warehouse/IngredientsManagement/CreateNewIngredient/CreateNewGradient";
import AdjustStock from "../screens/AdminScreens/Warehouse/IngredientsManagement/AdjustStock/MaterialAdjustStock";
import AdminEmergencyContactDetails from "../screens/AdminScreens/AdminEmergencyContactDetails/AdminEmergencyContactDetails";
import AdminBillingSubscription from "../screens/AdminScreens/AdminBuisnessManagement/AdminBillingSubscription/AdminBillingSubscription";
import AddUserLicense from "../screens/AdminScreens/AdminBuisnessManagement/AdminBillingSubscription/AddUserLicense/AddUserLicense";
import MaterialManagement from "../screens/AdminScreens/Warehouse/MaterialManagement/MaterialManagement";
import WasteLog from "../screens/AdminScreens/Warehouse/WasteLog/WasteLog";
import MaterialMgmt from "../screens/AdminScreens/Warehouse/MaterialManagement/Material/MaterialMgmt";
import CreateNewMaterial from "../screens/AdminScreens/Warehouse/MaterialManagement/CreateNewMaterial/CreateNewMaterial";
import ComponentManagement from "../screens/AdminScreens/Warehouse/ComponentManagement/ComponentsTable/ComponentManagement";

//UserManagement/Training
import Training from "../screens/AdminScreens/AdminUserManagement/Traininig/Training";
import AddTraining from "../screens/AdminScreens/AdminUserManagement/Traininig/AddTraining/AddTraining";
import Components from "../screens/AdminScreens/Warehouse/ComponentManagement/Components/Components";

import AdminCentralCommandScreen from "../screens/AdminScreens/AdminCentralCommandScreen/AdminCentralCommandScreen";
import SelectPaymentMethod from "../screens/AdminScreens/AdminBuisnessManagement/SelectPaymentMethod/SelectPaymentMethod";
import StaffDetails from "../screens/AdminScreens/AdminUserManagement/AdminStaffDetails/StaffDetails";
import ViewTraining from "../screens/AdminScreens/AdminUserManagement/Traininig/ViewTraining/ViewTraining";
import AdminProductJourney from "../screens/AdminScreens/AdminProductJourney/AdminProductJourney";
import AdminComplianceMGMT from "../screens/AdminScreens/AdminProductionManagement/AdminComplianceMGMT/AdminComplianceMGMT";
import AdminAllerganManagement from "../screens/AdminScreens/AdminProductionManagement/AdminAllerganManagement/AdminAllerganManagement";
import AddAllergen from "../screens/AdminScreens/AdminProductionManagement/AdminAllerganManagement/AddAllergen/AddAllergen";
import AllergenDetails from "../screens/AdminScreens/AdminProductionManagement/AdminAllerganManagement/AllergenDetails/AllergenDetails";
import AdminReceipeManagement from "../screens/AdminScreens/AdminProductionManagement/AdminReceipeManagement/AdminReceipeManagement";
import CreateRecipe from "../screens/AdminScreens/AdminProductionManagement/AdminReceipeManagement/CreateRecipe/CreateReceipe";
import ProcessManagement from "../screens/AdminScreens/ProcessManagement/ProcessMgmt";
import ProcessSetup from "../screens/AdminScreens/ProcessManagement/ProcessSetup/ProcessSetup";
import InstructionSetup from "../screens/AdminScreens/ProcessManagement/InstructionSetup/InstructionSetup";
import SummaryPage from "../screens/AdminScreens/ProcessManagement/Preview/Instructions/SummaryPage";
import ReciepeManagement from "../screens/AdminScreens/AdminProductionManagement/ReciepeManagement/ReciepeManagement";
import AdminEventLog from "../screens/AdminScreens/AdminBuisnessManagement/AdminEventLog/AdminEventLog";
import AdminAnalyticsReports from "../screens/AdminScreens/AdminBuisnessManagement/AdminAnalyticsReports/AdminAnalyticsReports";
import SummaryTabs from "../screens/AdminScreens/ProcessManagement/Preview/Tabs/SummaryTabs";
import AdminViewProductJourney from "../screens/AdminScreens/Warehouse/ComponentManagement/Components/OrderHistory/ViewProductJourney/ViewProductJourney";
// Supervisor Screen
import SupervisorCentralCommandScreen from "../screens/SupervisorScreens/SupervisorCentralCommandScreen/SupervisorCentralCommandScreen";
import SupervisorIngredientsMgmt from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorIngredientsManagement/SupervisorIngredients/SupervisorIngredientsMgmt";
import SupervisorAdjustStock from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorIngredientsManagement/SupervisorAdjustStock/SupervisorAdjustStock";
import SupervisorMaterial from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorMaterialManagement/SupervisorMaterialMgmt";
import SupervisorMaterialMgmt from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorMaterialManagement/SupervisorMaterial/SupervisorMaterialManagement";
import SupervisorWasteLog from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorWasteLog/SupervisorWasteLog";
import SupervisorComponentManagement from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorComponentManagement/SupervisorComponentsTable/SupervisorComponentManagement";
import SupervisorComponents from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorComponentManagement/SupervisorComponents/SupervisorComponents";
import SupervisorProductJourney from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorComponentManagement/SupervisorComponents/SupervisorProductJourney/SupervisorProductJourney";
import SupervisorReports from "../screens/SupervisorScreens/SupervisorReports/SupervisorReports";
import SupervisorReportsDetails from "../screens/SupervisorScreens/SupervisorReports/SupervisorReportsDetails/SupervisorReportsDetails";
import Equipment from "../screens/SupervisorScreens/Equipment/Equipment";
import SupEquipmentDetails from "../screens/SupervisorScreens/Equipment/SupEquipmentDetails/SupEquipmentDetails";
import SupTraining from "../screens/SupervisorScreens/Training/SubTraining";
import SupervisorRecipeProduction from "../screens/SupervisorScreens/SupervisorRecipeProduction/SupervisorRecipeProduction";
import SupervisorProductionSchedule from "../screens/SupervisorScreens/SupervisorProductionSchedule/SupervisorProductionSchedule";
import SupViewtraining from "../screens/SupervisorScreens/Training/SupViewTraining/SupViewTraining";
import StaffEquipment from "../screens/StaffScreens/StaffEquipment/StaffEquipment";
import StaffEquipmentDetails from "../screens/StaffScreens/StaffEquipment/StaffEquipmentDetails/StaffEquipmentDetails";
import EditProfile from "../screens/EditProfile/EditProfile";
import Profile from "../screens/Profile/Profile";
import SupervisorRecipeProductionOngoingTask from "../screens/SupervisorScreens/SupervisorRecipeProduction/OngoingTask/OngoingTask";
import SupervisorOrderChecklist from "../screens/SupervisorScreens/SupervisorRecipeProduction/OrderChecklist/OrderChecklist"


///////////////////////// staffScreen /////////////////////////////
import SupReciepe from "../screens/SupervisorScreens/Training/SupReciepe/SupReciepe";
import SupViewReciepe from "../screens/SupervisorScreens/Training/SupReciepe/SupViewReciepe/SupViewReciepe";

import StaffIngredientsMgmt from "../screens/StaffScreens/StaffWarehouse/StaffIngredientsManagement/StaffIngredients/StaffIngredientsMgmt";
import StaffAdjustStock from "../screens/StaffScreens/StaffWarehouse/StaffIngredientsManagement/StaffAdjustStock/StaffAdjustStock";
import StaffMaterial from "../screens/StaffScreens/StaffWarehouse/StaffMaterialManagement/StaffMaterialMgmt";
import StaffMaterialMgmt from "../screens/StaffScreens/StaffWarehouse/StaffMaterialManagement/StaffMaterial/StaffMaterialManagement";
import StaffWasteLog from "../screens/StaffScreens/StaffWarehouse/StaffWasteLog/StaffWasteLog";
import StaffComponentManagement from "../screens/StaffScreens/StaffWarehouse/StaffComponentManagement/StaffComponentsTable/StaffComponentManagement";
import StaffComponents from "../screens/StaffScreens/StaffWarehouse/StaffComponentManagement/StaffComponents/StaffComponents";
import StaffProductJourney from "../screens/StaffScreens/StaffWarehouse/StaffComponentManagement/StaffComponents/StaffProductJourney/StaffProductJourney";
import StaffTraining from "../screens/StaffScreens/StaffTraining/StaffTraining";
import StaffViewTraining from "../screens/StaffScreens/StaffTraining/StaffViewTraining/StaffViewTraining";
import StaffReciepe from "../screens/StaffScreens/StaffTraining/StaffReciepe/StaffReciepe";
import StaffViewReciepe from "../screens/StaffScreens/StaffTraining/StaffReciepe/StaffViewReciepe/StaffViewReciepe";
import StaffRecipeProductionOngoingTask from "../screens/StaffScreens/StaffRecipeProduction/OngoingTask/OngoingTask";
import StaffOrderChecklist from "../screens/StaffScreens/StaffRecipeProduction/OrderChecklist/OrderChecklist"
import StaffRecipeProduction from "../screens/StaffScreens/StaffRecipeProduction/StaffRecipeProduction"
import StaffProductionSchedule from "../screens/StaffScreens/StaffProductionSchedule/StaffProductionSchedule";
import EditIngredient from "../screens/AdminScreens/Warehouse/IngredientsManagement/EditIngredient/EditIngredient";
import EditMaterial from "../screens/AdminScreens/Warehouse/MaterialManagement/EditMaterial/EditMaterial";
import EditRecipeComponent from "../screens/AdminScreens/Warehouse/ComponentManagement/Components/EditRecipe/EditRecipeComponent";
import EditAllergen from "../screens/AdminScreens/AdminProductionManagement/AdminAllerganManagement/EditAllergen/EditAllergen";
import AdminEditStaffUser from "../screens/AdminScreens/AdminUserManagement/AdminEditStaffUser/AdminEditStaffUser";
import EditTraining from "../screens/AdminScreens/AdminUserManagement/Traininig/EditTraining/EditTraining";
import SupervisorReciepeProductJourney from "../screens/SupervisorScreens/SupervisorWarehouse/SupervisorComponentManagement/SupervisorComponents/SupervisorOrderHistory/SupervisorReciepeProductJourney/SupervisorReciepeProductJourney";
import StaffReciepeProductJourney from "../screens/StaffScreens/StaffTraining/StaffReciepe/StaffViewReciepe/StaffOrderHistory/StaffReciepeProductJourney/StaffReciepeProductJourney";
import MaterialAdjustStock from "../screens/AdminScreens/Warehouse/IngredientsManagement/AdjustStock/MaterialAdjustStock";
import CreateAComplianceMGMT from "../screens/AdminScreens/AdminProductionManagement/AdminComplianceMGMT/CreateAComplianceMGMT/CreateAComplianceMGMT";
import ProcessBuilder from "../screens/AdminScreens/ProcessManagement/ProcessBuilder/ProcessBuilder";
import CreateHACCPCompliance from "../screens/AdminScreens/ProcessManagement/ProcessBuilder/CreateHACCPCompliance/CreateHACCPCompliance";


export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<HomeLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/forgotPassword" element={<ForgetPassword />} />
        <Route path="/verifyCode" element={<VerifyCode />} />
        <Route path="/createPassword" element={<CreatePassword />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signupCode" element={<SignupCode />} />
        <Route path="/AdminSelectPlan" element={<AdminSelectPlan />} />
        <Route path="/AdminPayments" element={<AdminPayments />} />
        <Route path="/BakerySetup" element={<AdminBakerySetup />} />
      </Route>
      <Route element={<ProtectedLayout />}>
        {/* =================================================== Admin Screens  ======================================= */}
        <Route element={<RolesLayout roles={[roles.admin]} />}>
          <Route path="/AdminDashboard" element={<AdminDashboard />} />
          <Route
            path="/CentralCommandScreen"
            element={<AdminCentralCommandScreen />}
          />
          <Route
            path="/AdminOrderManagement"
            element={<AdminOrderManagement />}
          />
          <Route
            path="/AdminProductJourney"
            element={<AdminProductJourney />}
          />
           <Route
            path="/AdminProductManagement/CreateComplianceManagement"
            element={<CreateAComplianceMGMT />}
          />
          <Route
            path="/AdminProductManagement/ComplianceManagement"
            element={<AdminComplianceMGMT />}
          />
          <Route
            path="/AdminProductManagement/AllerganManagement"
            element={<AdminAllerganManagement />}
          />
          <Route
            path="/AdminProductManagement/AddAllergen"
            element={<AddAllergen />}
          />
          <Route
            path="/AdminProductManagement/EditAllergen"
            element={<EditAllergen />}
          />
          <Route
            path="/AdminProductManagement/AllergenDetails"
            element={<AllergenDetails />}
          />
          <Route
            path="/AdminProductManagement/EquipmentManagement"
            element={<EquipmentManagement />}
          />
          <Route
            path="/AdminProductManagement/productionschedule"
            element={<ProductionSchedule />}
          />
          <Route path="/AddEquipment" element={<AddEquipment />} />
          <Route path="/EquipmentDetails/view" element={<EquipmentDetails />} />
          <Route path="/EditOrder" element={<EditOrder />} />
          <Route path="/ViewOrder" element={<ViewOrder />} />
          <Route path="/EditEquipment" element={<EditEquipment />} />
          <Route path="/CreateOrder" element={<CreateOrder />} />
          <Route
            path="/AdminBuisnessManagement/BakerySetup"
            element={<BakerySetup />}
          />
          <Route
            path="/AdminBuisnessManagement/LocationManagement"
            element={<LocationManagement />}
          />
          {/* <Route
            path="/AdminBuisnessManagement/LocationManagement"
            element={<LocationManagement />}
          /> */}
          <Route
            path="/AdminBuisnessManagement/LocationManagement"
            element={<LocationManagement />}
          />
          <Route />
          <Route
            path="/AdminBuisnessManagement/BillingSubscription"
            element={<AdminBillingSubscription />}
          />
          {/* <Route
            path="/AdminBuisnessManagement/SelectPaymentMethod"
            element={<SelectPaymentMethod />}
          /> */}
          <Route
            path="/AdminBuisnessManagement/SelectPaymentMethod"
            element={<SelectPaymentMethod />}
          />
          <Route
            path="/AdminBuisnessManagement/EventLog"
            element={<AdminEventLog />}
          />
          <Route
            path="/AdminBuisnessManagement/AnalyticsReports"
            element={<AdminAnalyticsReports />}
          />
          <Route path="/AddUserLicense" element={<AddUserLicense />} />
          <Route
            path="/AdminEmergencyContactDetails"
            element={<AdminEmergencyContactDetails />}
          />
          <Route
            path="/AdminProductManagement/RecipeManagement"
            element={<AdminReceipeManagement />}
          />
          {/* 1{" "} */}
          <Route
            path="/RecipeManagement/CreateRecipe"
            element={<CreateRecipe />}
          />
          <Route path="/EditBakeryDetail" element={<EditBakeryDetail />} />
          <Route path="/AdminStaffMgmt" element={<AdminStaffMgmt />} />
          <Route path="/CreateNewStaffUser" element={<CreateNewStaffUser />} />
          <Route path="/AdminEditStaffUser" element={<AdminEditStaffUser />} />

          <Route path="/StaffDetails" element={<StaffDetails />} />
          <Route
            path="/Warehouse/IngredientsMgmt"
            element={<IngredientsMgmt />}
          />
          <Route
            path="/Warehouse/IngredientsMgmt/EditIngredient"
            element={<EditIngredient />}
          />
          <Route
            path="/Warehouse/IngredientsMgmt/CreateNewGradient"
            element={<CreateNewGradient />}
          />
          <Route path="/Warehouse/AdjustStock" element={<AdjustStock />} />
          <Route path="/Warehouse/MaterialMGMT/AdjustStock" element={<MaterialAdjustStock />} />

          <Route
            path="/Warehouse/MaterialManagement"
            element={<MaterialManagement />}
          />
          <Route path="/Warehouse/WasteLog" element={<WasteLog />} />
          <Route path="/Warehouse/MaterialMGMT" element={<MaterialMgmt />} />
          <Route
            path="/Warehouse/MaterialMGMT/CreateNewMaterial"
            element={<CreateNewMaterial />}
          />
          <Route
            path="/Warehouse/MaterialMGMT/EditMaterial"
            element={<EditMaterial />}
          />
          <Route
            path="/Warehouse/ComponentMGMT"
            element={<ComponentManagement />}
          />
          <Route path="/userManagement/training" element={<Training />} />
          {/* <Route
            path="/userManagement/training/addTraining"
            element={<AddTraining />}
          />
          <Route
            path="/userManagement/training/viewTraining"
            element={<ViewTraining />}
          />
          <Route
            path="/Warehouse/ComponentMGMT/CreateComponent"
            element={<Components />}
          /> */}
          <Route
            path="/userManagement/training/addTraining"
            element={<AddTraining />}
          />
          <Route
            path="/userManagement/training/EditTraining"
            element={<EditTraining />}
          />
          <Route
            path="/userManagement/training/viewTraining"
            element={<ViewTraining />}
          />
          <Route
            path="/Warehouse/ComponentMGMT/CreateComponent"
            element={<Components />}
          />
          <Route
            path="/ProductionManagement/ProcessManagement"
            element={<ProcessManagement />}
          />
           <Route
            path="/ProductionManagement/ProcessBuilder"
            element={<ProcessBuilder />}
          />
          <Route
            path="/ProductionManagement/ProcessManagement/ProcessSetup"
            element={<ProcessSetup />}
          />
          <Route
            path="/ProductionManagement/ProcessManagement/InstructionSetup"
            element={<InstructionSetup />}
          />
           <Route
            path="/ProductionManagement/ProcessManagement/CreateHACCPCompliance"
            element={<CreateHACCPCompliance />}
          />
          <Route
            path="/ProductionManagement/ProcessManagement/InstructionSetup/Summary"
            element={<SummaryTabs />}
          />
          {/* /////////////Production Management/////////////////////////// */}
          <Route
            path="/productionManagement/ReciepeBuilder"
            element={<ReciepeManagement />}
          />
          <Route
            path="/productionManagement/EditReciepeBuilder"
            element={<EditRecipeComponent />} />

          <Route
            path="/Warehouse/ComponentMGMT/OrderHistory/ViewProductJourney"
            element={< AdminViewProductJourney />}
          />
          {/* ////////////////////////Material Management ///////////////////////////// */}

          <Route
            path="/AdminCustomerManagement"
            element={< AdminCustomerManagement />}
          />
          <Route
            path="/AdminCustomerManagement/AdminAddCustomer"
            element={< AdminAddCustomer />}
          />
          <Route
            path="/AdminCustomerManagement/AdminEditCustomer"
            element={< AdminEditCustomer />}
          />
          <Route
            path="/AdminCustomerManagement/CustomerManagementDetails"
            element={< CustomerManagementDetails />}
          />

          <Route
            path="/AdminCustomerManagement/OrderHistoryDetails"
            element={< OrderHistoryDetails />}
          />
          <Route
            path="/AdminCustomerManagement/OrderHistoryEditOrder"
            element={< OrderHistoryEditOrder />}
          />
          <Route
            path="/AdminCustomerManagement/OrderHistoryProductJourney"
            element={< OrderHistoryProductJourney />}
          />

          <Route
            path="/AdminVendorManagement"
            element={< AdminVendorManagement />}
          />
          <Route
            path="/AdminVendorManagement/AdminAddVendor"
            element={< AdminAddVendor />}
          />
          <Route
            path="/AdminVendorManagement/VendorManagementDetails"
            element={< VendorManagementDetails />}
          />
          <Route
            path="/AdminVendorManagement/AdminEditVendor"
            element={< AdminEditVendor />}
          />


        </Route>

        {/* =================================================== supervisor Screens  ======================================= */}
        <Route element={<RolesLayout roles={[roles.supervisor]} />}>
          <Route
            path="/SupervisorDashboard"
            element={<SupervisorDashboard />}
          />
          <Route
            path="/SupervisorCentralCommandScreen"
            element={<SupervisorCentralCommandScreen />}
          />

          <Route
            path="/SupervisorWarehouse/SupervisorIngredients"
            element={<SupervisorIngredientsMgmt />}
          />

          <Route
            path="/SupervisorWarehouse/SupervisorAdjustStock"
            element={<SupervisorAdjustStock />}
          />
          <Route
            path="/SupervisorWarehouse/SupervisorMaterial"
            element={<SupervisorMaterial />}
          />
          <Route
            path="/SupervisorWarehouse/SupervisorMaterialMgmt"
            element={<SupervisorMaterialMgmt />}
          />

          <Route
            path="/SupervisorWarehouse/SupervisorWasteLog"
            element={<SupervisorWasteLog />}
          />
          <Route
            path="/Warehouse/SupervisorComponentMGMT"
            element={<SupervisorComponentManagement />}
          />
          <Route
            path="/Warehouse/SupervisorRecipeDetails"
            element={<SupervisorComponents />}
          />
          <Route
            path="/Warehouse/SupervisorProductJourney"
            element={<SupervisorProductJourney />}
          />
          <Route path="/SupervisorReports" element={<SupervisorReports />} />
          <Route
            path="/supervisor/ReportsDetails"
            element={<SupervisorReportsDetails />}
          />

          <Route
            path="/SupervisorEquipmentManagement"
            element={<Equipment />}
          />
          <Route
            path="/supervisor/EquipmentDetails"
            element={<SupEquipmentDetails />}
          />
          <Route path="/Training" element={<SupTraining />} />
          <Route
            path="/SupervisorRecipeProduction"
            element={<SupervisorRecipeProduction />}
          />

          <Route
            path="/supervisor/RecipeProduction/OngoingTask"
            element={<SupervisorRecipeProductionOngoingTask />}
          />

          <Route
            path="/SupervisorProductionSchedule"
            element={<SupervisorProductionSchedule />}
          />
          <Route path="/Supervisor/OrderChecklist" element={<SupervisorOrderChecklist />} />

          <Route
            path="/Training/SupervisorProductJourney"
            element={<SupervisorReciepeProductJourney />}
          />

          <Route path="/Training/ViewTraining" element={<SupViewtraining />} />
          <Route path="/Training/Reciepe" element={<SupReciepe />} />
          <Route path="/Training/ViewReciepe" element={<SupViewReciepe />} />
          {/* <Route path="/Training/Reciepe" element={<SupReciepe />} /> */}
        </Route>

        {/* =================================================== staff Screens  ======================================= */}
        <Route element={<RolesLayout roles={[roles.staff]} />}>
          <Route path="/StaffDashboard" element={<StaffDashboard />} />
          <Route path="/StaffEquipment" element={<StaffEquipment />} />
          <Route
            path="/StaffEquipmentDetails"
            element={<StaffEquipmentDetails />}
          />
          <Route path="/StaffTraining" element={<StaffTraining />} />
          <Route path="/Staff/ViewTraining" element={<StaffViewTraining />} />
          <Route path="/Staff/Recipe" element={<StaffReciepe />} />
          <Route path="/Staff/ViewRecipe" element={<StaffViewReciepe />} />

          <Route
            path="/StaffRecipeProduction"
            element={<StaffRecipeProduction />}
          />
          <Route
            path="/StaffReciepeProductJourney"
            element={<StaffReciepeProductJourney />}
          />

          <Route
            path="/staff/RecipeProduction/OngoingTask"
            element={<StaffRecipeProductionOngoingTask />}
          />
          <Route path="/Staff/OrderChecklist" element={<StaffOrderChecklist />} />

          <Route
            path="/StaffProductionSchedule"
            element={<StaffProductionSchedule />}
          />

        </Route>

        {/* =================================================== Common Screens  ======================================= */}

        <Route path="/Profile" element={<Profile />} />
        <Route path="/EditProfile" element={<EditProfile />} />
        <Route path="/settings" element={<Settings />} />

        <Route path="/notifications" element={<Notifications />} />
        <Route path="/helpSupport" element={<HelpSupport />} />
        <Route path="/TermsConditions" element={<TermsConditions />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Faqs" element={<Faqs />} />
        <Route path="/EmergencyContacts" element={<EmergencyContacts />} />
        <Route
          path="/StaffWarehouse/StaffIngredients"
          element={<StaffIngredientsMgmt />}
        />

        <Route
          path="/StaffWarehouse/StaffAdjustStock"
          element={<StaffAdjustStock />}
        />
        <Route
          path="/StaffWarehouse/StaffMaterial"
          element={<StaffMaterial />}
        />
        <Route
          path="/StaffWarehouse/StaffMaterialMgmt"
          element={<StaffMaterialMgmt />}
        />

        <Route
          path="/StaffWarehouse/StaffWasteLog"
          element={<StaffWasteLog />}
        />
        <Route
          path="/Warehouse/StaffComponentMGMT"
          element={<StaffComponentManagement />}
        />
        <Route
          path="/Warehouse/StaffRecipeDetails"
          element={<StaffComponents />}
        />
        <Route
          path="/Warehouse/StaffProductJourney"
          element={<StaffProductJourney />}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<RolesLayout roles={[roles.dealership]} />}>
          <Route
            path="/verificationProcess"
            element={<VerificationProcess />}
          />
        </Route>
      </Route>
      {/* </Route> */}
      <Route
        path="*"
        element={
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
          // extra={<Button type="primary">Back Home</Button>}
          />
        }
      />
    </>
  )
);
